import { ThemeContext } from "app/uicomponents/macrocomponents/RootLayout";
import * as React from "react";
import { useContext } from "react";

interface SVGProps extends React.SVGProps<SVGSVGElement> {}

const HexagonTick: React.FC<SVGProps> = (props) => {
  const { isDarkMode } = useContext(ThemeContext);
  const finalColor = props?.fill?.trim() ? props?.fill?.trim() : isDarkMode ? "#FFFFFF" : "#00132E";
  const { width, height } = props;

  return (
    <svg
      width={width ?? 21}
      height={height ?? 16}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20 18"
      style={{ color: finalColor }}
      {...props}
    >
      <g clipPath="url(#clip0_30088_5851)">
        <path
          d="M13.4687 1.26519H13.4729L13.5235 1.26625C14.1466 1.27152 14.7311 1.61259 15.0481 2.15663L18.5009 8.08194C18.831 8.64812 18.831 9.35188 18.5009 9.91858L15.0486 15.8439C14.728 16.3937 14.1372 16.7353 13.5068 16.7353H6.49373C5.86282 16.7353 5.27205 16.3937 4.9519 15.8444L3.49975 13.3525L1.49907 9.91911C1.16902 9.35294 1.16902 8.64917 1.49907 8.08247L4.9519 2.15663C5.27205 1.60679 5.86334 1.26519 6.49373 1.26519H13.4687ZM13.5063 0H6.49373C5.41648 0 4.42005 0.57619 3.87361 1.51401L0.420784 7.43933C-0.140261 8.40246 -0.140261 9.59701 0.420784 10.5601L2.42146 13.9936L3.87361 16.4855C4.42005 17.4233 5.41648 17.9995 6.49373 17.9995H13.5063C14.5835 17.9995 15.5799 17.4233 16.1264 16.4855L19.5792 10.5601C20.1403 9.59701 20.1403 8.40193 19.5792 7.43933L16.1264 1.51401C15.5841 0.584097 14.6007 0.00948894 13.5339 0.00105433C13.5245 0 13.5157 0 13.5063 0Z"
          fill="currentColor"
        />
        <path
          d="M15.0481 2.15663C14.7311 1.61259 14.1466 1.27152 13.5235 1.26625L6.49373 1.26519C5.67104 1.28653 5.29366 1.41767 4.9519 2.15663L1.49907 8.08247C1.07687 8.83134 1.06145 9.25179 1.49907 9.91911L3.49975 13.3525L4.9519 15.8444C5.77603 18.0026 6 17 6.49373 16.7353H13.5068C14.3285 16.7685 14.6642 16.5808 15.0486 15.8439L18.5009 9.91858C18.9874 9.20133 18.9521 8.7992 18.5009 8.08194L15.0481 2.15663Z"
          fill="currentColor"
        />
        <path
          d="M15.4317 3.78605C15.2863 3.81006 14.1602 4.84339 14.1602 4.84339C12.0551 6.57881 10.0465 8.42628 8.17852 10.4165C8.07322 10.5285 7.9221 10.7419 7.81901 10.8278C7.79522 10.8478 7.79125 10.8624 7.75292 10.8491C7.23041 9.89402 6.61977 8.96029 5.9501 8.09813C5.75625 7.84869 5.15179 7.06302 4.91344 6.95008C4.36052 6.68775 3.80716 7.31068 4.06534 7.84736C4.21601 8.16083 4.68963 8.67616 4.91388 9.00653C5.57033 9.97539 6.15321 11.0483 6.67044 12.0981C6.87663 12.516 7.10881 13.1901 7.34275 13.5485C7.4855 13.7668 7.7939 13.8228 8.01462 13.6903C8.48515 13.1225 8.89048 12.4943 9.33326 11.9011C10.744 10.0101 12.3331 8.17861 13.9685 6.47966C14.5391 5.88651 15.3171 5.24624 15.8238 4.63931C15.8661 4.58862 15.9365 4.51214 15.9599 4.45389C16.107 4.08084 15.8308 3.72069 15.4317 3.78605Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_30088_5851">
          <rect width="20" height="18" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default HexagonTick;
